module.exports = __webpack_public_path__ + "static/img/PerennialSociete_logo.7752c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PerennialSociete_logo.png
// module id = 284
// module chunks = 1